import React, { createContext } from 'react'
import { useState } from 'react'

interface ProfileContextType {
  firstName: string
  lastName: string
  phone: string
  profilePic: File | null
  handleFirstName: (value: string) => void
  handleLastName: (value: string) => void
  handlePhoneNumber: (value: string) => void
  handleProfilePic: (value: File | null) => void
}

interface ProfileProviderPropsType {
  children?: React.ReactNode
}

const defaultContextValue = {
  firstName: '',
  lastName: '',
  phone: '',
  profilePic: null,
  handleFirstName: () => {},
  handleLastName: () => {},
  handlePhoneNumber: () => {},
  handleProfilePic: () => {},
}

const ProfileContext = createContext<ProfileContextType>(defaultContextValue)

const ProfileProvider = ({ children }: ProfileProviderPropsType) => {
  const [firstName, setFirstName] = useState<string>('')
  const [lastName, setLastName] = useState<string>('')
  const [phone, setPhoneNumber] = useState<string>('')
  const [profilePic, setProfilePic] = useState<File | null>(null)

  const handleFirstName = (value: string) => {
    setFirstName(value)
  }

  const handleLastName = (value: string) => {
    setLastName(value)
  }

  const handlePhoneNumber = (value: string) => {
    setPhoneNumber(value)
  }

  const handleProfilePic = (value: File | null) => {
    setProfilePic(value)
  }

  return (
    <ProfileContext.Provider
      value={{
        firstName,
        lastName,
        phone,
        profilePic,
        handleFirstName,
        handleLastName,
        handlePhoneNumber,
        handleProfilePic,
      }}
    >
      {children}
    </ProfileContext.Provider>
  )
}

export { ProfileContext, ProfileProvider }
